//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DataTable from '../../general/DataTable';
export default {
  name: 'SmokingTable',
  components: {
    DataTable: DataTable
  },
  props: {
    data: {
      type: Array,
      default: null
    },
    person: {
      type: Object,
      default: null
    }
  },
  computed: {
    headerDefinition: function headerDefinition() {
      return [{
        name: t('health', 'Date'),
        columnId: 'date',
        type: 'date',
        show: true,
        default: function _default() {
          return new Date().toISOString().slice(0, 10);
        }
      }, {
        name: t('health', 'Cigarettes'),
        columnId: 'cigarettes',
        type: 'number',
        show: this.person.smokingColumnCigarettes
      }, {
        name: t('health', 'Withdrawal symptoms'),
        columnId: 'desireLevel',
        type: 'select',
        options: [{
          id: 0,
          label: t('health', 'None')
        }, {
          id: 1,
          label: t('health', 'Noticeable')
        }, {
          id: 2,
          label: t('health', 'Some')
        }, {
          id: 3,
          label: t('health', 'Moderate')
        }, {
          id: 4,
          label: t('health', 'Strong')
        }, {
          id: 5,
          label: t('health', 'Very strong')
        }, {
          id: 6,
          label: t('health', 'Extreme')
        }],
        show: this.person.smokingColumnDesireLevel
      }, {
        name: t('health', 'Saved money'),
        columnId: 'savedMoney',
        type: 'calculate',
        calc: function calc(dataset) {
          // console.debug('calc', { this: this, dataset: dataset })
          if (!this.calcData.price || !this.calcData.start) {
            return null;
          } else if (dataset.cigarettes >= this.calcData.start) {
            return t('health', 'Nothing saved');
          } else {
            var count = this.calcData.start - dataset.cigarettes;
            var currency = this.calcData.currency ? this.calcData.currency : '';
            return '' + Math.round(count * this.calcData.price * 100) / 100 + ' ' + currency;
          }
        },
        calcData: {
          price: this.person.smokingPrice,
          currency: this.person.currency,
          start: this.person.smokingStartValue
        },
        show: this.person.smokingColumnSavedMoney
      }, {
        name: t('health', 'Comment'),
        columnId: 'comment',
        type: 'longtext',
        show: true
      }];
    }
  },
  methods: {
    addItem: function addItem(item) {
      // console.debug('add item', item)
      this.$store.dispatch('smokingDatasetsAppend', item);
    },
    updateItem: function updateItem(item) {
      // console.debug('update item', item)
      this.$store.dispatch('smokingDatasetsUpdate', item);
    },
    deleteItem: function deleteItem(item) {
      // console.debug('delete item', item)
      this.$store.dispatch('smokingDatasetsDelete', item);
    }
  }
};